import { render, staticRenderFns } from "./CheckForm.vue?vue&type=template&id=2811ef32&scoped=true&"
import script from "./CheckForm.vue?vue&type=script&lang=js&"
export * from "./CheckForm.vue?vue&type=script&lang=js&"
import style0 from "./CheckForm.vue?vue&type=style&index=0&id=2811ef32&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2811ef32",
  null
  
)

export default component.exports